export default __webpack_public_path__ + "static/media/async.aff1d18a.PNG";